export { ErrorApp } from './app.component';
